module.exports = __webpack_public_path__ + "img/picture_swiper.f114034e.png";